import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { API_URL } from '@constants';
import { TreeEntry } from '@models';

@Service()
export class TreeService {
  http = inject(HttpClient);

  getTree = (params?: Record<string, string | number | boolean>) =>
    this.http.get<TreeEntry>(`${API_URL}/tree`, { params });

  getTreeWithFiles = () =>
    this.http.get<TreeEntry>(`${API_URL}/tree`, {
      params: { files: true },
    });

  getResourceTree = (
    url: string,
    params?: Record<string, string | number | boolean>
  ) => this.http.get<TreeEntry>(`${API_URL}/${url}`, { params });
}
